<template>
  <div class="electric">
    <box title="隐患预警">
      <div class="electric__context">
        <div class="query">
          <f-filter
            ref="filter"
            :filter-form="formFilter"
            @sendForm="getForm"
            @on-reset="onRefresh"
          ></f-filter>
        </div>
        <div class="result">
          <el-tabs v-model="activeName"  @tab-click="handleClick">
            <el-tab-pane v-for="item in statusarr" :label="item.label" :name="item.value + ''"></el-tab-pane>

          </el-tabs>
        </div>
        <div class="list-table">
          <el-table v-loading="loading" :data="reportList" class="tableList">
            <el-table-column
              show-overflow-tooltip
              prop="deptName"
              align="center"
              label="单位名称"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="monitorName"
              align="center"
              label="监测点名称"
            ></el-table-column>
            <el-table-column
              prop="riskLevelName"
              align="center"
              label="隐患等级"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="alertLevelName"
              width="160"
              align="center"
              label="隐患类型"
            ></el-table-column>
            <el-table-column prop="status" align="center" label="处置状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">未处理</span>
                <span v-if="scope.row.status == 2">已处理</span>
                <span v-if="scope.row.status == 3">处理中</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              label="开始时间"
            ></el-table-column>
            <el-table-column prop="expireDay" align="center" label="逾期处置">
              <template slot-scope="scope">
                <span>{{ scope.row.expireDay }}天</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="showDialog(scope.row)"
                  v-if="scope.row.status == 1 || scope.row.status == 3"
                  v-show="menusList.indexOf('ALARM_RISK_HANDLE')!='-1'"
                >
                  处理</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="showDialog(scope.row)"
                  v-if="scope.row.status == 2"
                >
                  查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="float: right; margin-right: 10px; margin-top: 10px">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="pageNum"
            layout="total,prev, pager, next, jumper"
            :total="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </box>
    <el-dialog
      title="隐患预警处置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      class="electricDialog02"
    >
      <div class="electricDialog__content" v-if="statusHistory != 2">
        <div class="content_top">
          <span> <img src="../img/icon.png" />事件处理</span>
        </div>

        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="measure"
        >
        </el-input>
        <div class="confirm">
          <el-checkbox
            style="
              font-family: OPPOSans-M, OPPOSans;
              font-weight: normal;
              color: #252b3c;
            "
            v-model="checked"
            >确定已整改</el-checkbox
          >
          <el-button type="primary" class="btn" @click="onSubmit"
            >提 交</el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="statusHistory != 1">
        <div class="footer__title">
          <img src="../img/historyIcon.png" />
          <p>处理历史</p>
        </div>
        <div class="step">
          <el-timeline
            v-for="(activity, index) in activities"
            :reverse="true"
            :key="index"
          >
            <el-timeline-item
              :timestamp="activity.updateTime"
              placement="top"
              color="#2A62FF"
            >
              <div class="timeline">
                <span class="measure">{{ activity.measure }}</span>

                <span class="handlerName">
                  <i
                    :style="
                      activity.status == '处理中'
                        ? 'color:#2A62FF'
                        : 'color:#252B3C'
                    "
                    >{{ activity.status }}</i
                  >
                  <p>{{ activity.handlerName }}</p></span
                >
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import box from "../../component/box";
import fFilter from "../../component/filter";
import Vue from "vue";
import qs from "qs";
export default {
  name: "electroWarn",
  components: { box, fFilter },
  data() {
    return {
      loading: false,
      startDate: "",
      endDate: "",
      value: "",
      activeName: '9',
      statusarr: [
        {
          value: "9",
          label: "全部",
        },
        {
          value: 3,
          label: "未处理",
        },
        {
          value: 4,
          label: "已处理",
        },
        {
          value: 5,
          label: "处理中",
        },
      ],
      formFilter: [
        {
          name: "起止时间",
          endDate: "endDate",
          startDate: "startDate",
          type: "date",
          span: 9,
        },

        {
          name: "隐患等级",
          type: "levelSelect",
          field: "riskLevel",
          span: 5,
        },
        {
          name: "隐患类型",
          type: "hiddenSelect",
          field: "alertLevel",
          span: 5,
        },
      ],
      menusList: [],
      status: "",
      statusHistory: 1,
      riskLevel: "",
      alertLevel: "",
      reportList: [],
      page: 1,
      pageNum: 10,
      pageSize: 0,
      dialogVisible: false,
      measure: "",
      checked: false,
      riskId: null,
      count: {
        totalCount: 0,
        handledCount: 0,
        unHandledCount: 0,
      },
      activities: [],
      formdata:{
        endTime: "",
        faultCode: "",
        handleStatus: "",
        startTime: "",
      },
    };
  },
  methods: {
    handleClick(tab, event) {

      this.queryList(this.formdata)
    },
    getForm(form, key) {
      if (key) {
        this.page = 1;
        this.queryList(form);
        this.queryRiskCount(form);
      } else {
        this.queryList(form);
        this.queryRiskCount(form);
      }
    },
    onRefresh(form) {
      this.formdata=form
      this.queryList(form);
    },
    queryList(form = {}) {
      this.loading = true;
      this.queryRiskCount(form);
      this.reportList = [];
      const params = {
        url: "/risk/page",
        method: "post",
        data: {
          alertLevel: form.alertLevel,
          startTime: form.startDate,
          endTime: form.endDate || "",
          pageNum: form.page == 1 ? form.page : this.page, //页数
          riskLevel: form.riskLevel,
          showNum: this.pageNum, //每页数量
          status: this.activeName==9?'':this.activeName - 2,
        },
      };
      Axios.ajax(params).then((res) => {
        this.loading = false;
        this.reportList = res.data.dataList;
        this.pageSize = res.data.totalNum;
      });
    },

    queryRiskCount(form = {}) {

      Axios.ajax({
        url: "/risk/count",
        method: "post",
        data: {
          startTime: form.startDate || "", //默认为查全部
          endTime: form.endDate,
          riskLevel: form.riskLevel,
          status: form.status,
          alertLevel: form.alertLevel,

        }
      }).then(({ data }) => {
        this.count.totalCount = data.totalCount;
        this.count.handledCount = data.handledCount;
        this.count.unHandledCount = data.unHandledCount;
      });
    },
    onSubmit() {
      Axios.ajax({
        url: "/risk/handle",
        method: "post",
        data: {
          measure: this.measure,
          riskId: this.riskId,
          status: this.checked ? 2 : 3,
        },
      }).then((res) => {
        this.queryList();
        this.dialogVisible = false;
        this.measure = "";
        this.riskId = "";
        this.checked = "";
        if (res.resultCode == 0) {
          this.$message.success("处理成功！");
        } else {
          this.$message.warning("处理失败！");
        }
      });
    },
    filterData() {
      this.page = 1;
      this.queryList();
    },
    showDialog(row) {
      this.riskId = row.riskId;
      this.dialogVisible = true;
      this.statusHistory = row.status;
      Axios.ajax({
        url: "/risk/handleHistory",
        method: "post",
        data: {
          riskId: row.riskId,
        },
      }).then(({ data }) => {
        this.activities = data;
      });
    },
    // 当前页数
    pageChange(val) {
      this.page = val;
      this.queryList();
    },
  },
  created() {},
  mounted() {
    this.menusList=Vue.prototype.menusList
    this.queryList();
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.electric {
  .electric__context {
    height: 100%;
    padding: 36px;
    overflow: auto;
    .query {
      height: 60px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      .font {
        margin: 0 12px 0 20px;
      }
      .font:nth-child(1) {
        margin-left: 0px;
      }
    }
    .result {
      font-size: 14px;
      color: #252b3c;
      p {
        margin: 12px 0;
      }
      span {
        margin-right: 12px;
      }
    }
    .list-table {
      margin-top: 20px;
      height: 500px;
      .tableList {
        height: 100%;
        overflow: auto !important;
      }
    }
  }
}
</style>

<style lang="less">
.electricDialog02 {
  .el-dialog {
    padding: 0 45px;
    width: 759px;
    border-radius: 8px;
    .el-dialog__header {
      text-align: center;
      font-weight: normal;
      .el-dialog__headerbtn {
        right: 65px;
        font-size: 24px;
      }
    }
    .el-dialog__body {
      padding-bottom: 0px;
      .electricDialog__content {
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f0f0;
        .content_top {
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;
          span {
            font-size: 16px;
            font-weight: normal;
            color: #252b3c;
            img {
              margin-right: 12px;
            }
          }
          .el-checkbox {
            font-size: 14px;
          }
        }
        .el-textarea {
          .el-textarea__inner {
            min-height: 80px !important;
            height: 80px !important;
          }
        }
        .confirm {
          padding-top: 20px;
          text-align: right;
          .el-button {
            margin-left: 32px;
            background-color: #2a62ff;
            border-color: #2a62ff;
          }
        }
      }
    }

    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .footer__title {
        margin: 16px 4px;
        display: flex;
        p {
          margin-left: 12px;
          font-size: 16px;
          color: #252b3c;
        }
      }
      .step {
        font-size: 14px;
        color: #252b3c;
        overflow: auto;
        max-height: 251px;
        padding: 10px;
        .timeline {
          display: flex;
          justify-content: space-between;
        }
        .el-timeline-item__tail {
          display: block;
          border-left: 1px solid rgba(42, 98, 255, 0.3);
        }
        .measure {
          width: 80%;
        }
        .handlerName {
          width: 15%;
          min-height: 50px;
          position: relative;
          i {
            position: absolute;
            top: -20px;
          }
          p {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
